export const GLOBAL_PREVIEW_MODE = false

export const ILLUSTRATION_IMAGES = [
  'budgetvaluation.webp',
  'data&analytics.webp',
  'devops.webp',
  'growthstrategy.webp',
  'innovationconsulting.webp',
  'interactiveprototyping.webp',
  'keyperformanceindicators.webp',
  'maintenance.webp',
  'product.webp',
  'systemstrategyarchitecture.webp',
  'technical&productsupport.webp',
  'technicalhandover.webp',
  'technicalscope.webp',
  'testing&qualityassurance.webp',
  'ux&uidesign.webp',
  'web&mobiledevelopment.webp',
  'designdevelopment.webp',
  'developmentandlaunch.webp',
  'enhancement.webp',
  'goals.webp',
  'growthsupport.webp',
  'imaginationevaluation.webp',
  'insight.webp',
  'productimagination.webp',
  'security.webp',
  'solutions.webp',
  'sportdivision.webp',
  'sport.webp',
  'technology.webp',
  'workshops.webp',
].map((name) => `/images/placeholders/illustration/${name}`)

export const LIFESTYLE_IMAGES = ILLUSTRATION_IMAGES

export const PREVIEW_COPY_OVERRIDES = {
  header: {
    contactButton: 'talk to us',
  },
  home: {
    hero: {
      firstPartOfTitle: 'we use intelligent',
      secondPartOfTitle: 'tools to create',
      thirdPartOfTitle: 'human-centred products',
      content: `me&my Friends is a digital product studio. Since 2006, we have helped ambitious organisations turn complex ideas into web platforms, mobile apps, and custom software.

We combine strategy, design, engineering, and intelligent technology to create products that work for the businesses and people who use them.`,
      ctaText: 'explore our work',
    },
    whoWeAre: {
      content: `
Better technology starts with a better understanding of people’s needs.

Business tools are evolving quickly. AI creates new opportunities to explore ideas, automate processes, and build digital products more efficiently.

We see technology as a means, not the end. The value comes from understanding the people, organisations, and real-world situations behind every product. This means listening carefully, asking the right questions, and making decisions that align business goals with better user experiences.

Our team brings those perspectives together, working alongside yours to turn opportunities into practical, effective digital products.`,
    },
  },
}

export const getPreviewCopy = <T extends any>(
  path: string,
  originalContent: T
): T => {
  if (!GLOBAL_PREVIEW_MODE) return originalContent

  const keys = path.split('.')
  let current: any = PREVIEW_COPY_OVERRIDES
  for (const key of keys) {
    if (!current || typeof current !== 'object') return originalContent
    current = current[key]
  }

  if (current !== undefined && typeof current !== 'object') {
    return current as unknown as T
  }

  if (current && typeof current === 'object') {
    if (typeof originalContent === 'object' && originalContent !== null) {
      return {
        ...(originalContent as Record<string, any>),
        ...current,
      } as T
    }
    return current as unknown as T
  }

  return originalContent
}

export const getDeterministicImage = (seed: string, list: string[]): string => {
  let hash = 0
  for (let i = 0; i < seed.length; i++) {
    hash = seed.charCodeAt(i) + ((hash << 5) - hash)
  }
  const index = Math.abs(hash) % list.length
  return list[index]
}

export const PREVIEW_CASE_STUDIES_ORDER = [
  '/garett',
  '/football-rules',
  '/inea',
  '/gpw',
  '/latin-dance-passion',
  '/jean-louis-david',
  '/the-ifab-web',
  '/var',
  '/fuelo',
  '/north-fish',
  '/stare-powazki',
  '/ca-ubezpieczenia',
  '/the-ifab',
  '/adidas',
  '/wasza-warszawa',
  '/fg-energy',
  '/imall',
  '/lot-pos',
  '/moxly',
  '/t-mobile',
  '/learning',
  '/lot',
]

export const MOCK_PREVIEW_CASES: Record<string, any> = {
  '/fuelo': {
    id: 'fuelo-preview-id',
    slug: '/fuelo',
    platforms: ['Web', 'Mobile'],
    t: [
      {
        contentHeader: 'FUELO',
        firstPartOfTitle: 'smart fuel management',
        secondPartOfTitle: 'and fleet tracking',
        subtitle: 'FUELO',
        excerpt: 'Comprehensive fleet monitoring and fuel management system empowering businesses with real-time operational efficiency.',
        ctaText: 'explore case study',
        languages_id: { code: 'en' },
      },
    ],
    desktopImage: {
      id: 'fuelo-desktop-image',
    },
    coverImage: '/images/placeholders/cases/fg-energy-cover.webp',
  },
}


export const reorderCasesForPreview = (cases: any[] = []): any[] => {
  if (!GLOBAL_PREVIEW_MODE) return cases

  const casesMap = new Map<string, any>()
  cases.forEach((item) => {
    if (item?.slug) {
      casesMap.set(item.slug, item)
    }
  })

  // Inject mocks if not in directus
  Object.keys(MOCK_PREVIEW_CASES).forEach((slug) => {
    if (!casesMap.has(slug)) {
      casesMap.set(slug, MOCK_PREVIEW_CASES[slug])
    }
  })

  const ordered: any[] = []
  const usedSlugs = new Set<string>()

  PREVIEW_CASE_STUDIES_ORDER.forEach((slug) => {
    const item = casesMap.get(slug)
    if (item) {
      ordered.push(item)
      usedSlugs.add(slug)
    }
  })

  // Add any remaining items from directus not explicitly in the ordered list
  cases.forEach((item) => {
    if (item?.slug && !usedSlugs.has(item.slug)) {
      ordered.push(item)
    }
  })

  return ordered
}

export const getCaseStudyCoverUrl = (caseStudy: any): string => {
  if (caseStudy?.coverImage) {
    return caseStudy.coverImage
  }
  const cleanSlug = (caseStudy?.slug || '').replace(/^\//, '')
  if (cleanSlug === 'fuelo') {
    return '/images/placeholders/cases/fg-energy-cover.webp'
  }
  return `/images/placeholders/cases/${cleanSlug}-cover.webp`
}

